// extracted by mini-css-extract-plugin
module.exports = {"minimumScreenWidth":"320px","mobileScreenWidth":"600px","page":"style_page__3kmsE"};